import React from 'react';

const sadam = {
	'sadam.pealkiri': 'Varbla puhkeküla sadam',
	'sadam.blokk1.tutvustus': () => (
		<>
			<h2 className='title is-2'>Sadam</h2>
			<p>
				Varbla Puhkeküla on avanud sadama, mis ootab ja tervitab kõiki meretsi
				tulijaid.
			</p>
			<p>
				Meie juurde pääseb kuni 2,5 m süvise purjekaga, sadam võimaldab vastu
				võtta kuni 30 alust.
			</p>
			<p>
				Ligi 1 km pikkune sissesõidukanal on rahulik ja turvaline, kanalit
				ääristav muul loob romantilise tunde nii meretsi saabujatele kui ka
				jalutuskäiku harrastavatele külalistele.
			</p>
			<p>
				Ootame mereturiste - kaatriga tulijaid, purjetajaid, kalamehi ja kõiki,
				keda köidab privaatne mererand, puhas loodus ja sadamamelu. Kosutavat
				kõhutäidet ja karastavat joogipoolist pakume motelli pubiruumis või
				sadama restoranis.
			</p>
			<p>
				Saame pakkuda teile ettetellimisel toitlustamist (+372 5061879 , +372
				53315325) ning saadavuse korral ka saunateenuseid.
			</p>
			<p>Pesemise ja tualeti kasutamise võimalus sadama saunamajas.</p>{' '}
			<p>
				Võimalik on rentida ka grilli ja jalgrattaid. Liivarand asub sadamast ca
				400m kaugusel.{' '}
			</p>
			<p>Teljepoi koordinaadid: 58° 25′46″ N, 23° 40′7″ E</p>
			<p>
				<h3 className='subtitle'>Kontakttelefonid:</h3>
				<span>+372 5060892 Heino (sadamakapten)</span>
				<br />
				<span>+372 5061879 Marika</span>
				<br />
				<span>+372 53315325 Markus</span>
			</p>
			<p>
				<h3 className='subtitle'>Riiklik järelevalve:</h3>
				<span>Piirivalve Merevalvekeskus +372 6191224</span> <br /> Hädaabi: 112
			</p>
		</>
	),
	'sadam.blokk1.koordinaadid': () => (
		<>
			<a
				href='https://www.sadamaregister.ee/SadamaRegister/search?nimi=Varbla+Puhkek%C3%BCla+sadam&aadress=&_teenused=on&_ylesanded=on&_veekoguLiigid=on&_veekogud=on'
				target='_blank'
				rel='noopener noreferrer'
			>
				<h2 className='title'>Sadama koordinaadid:</h2>
			</a>
			<p>Põhjalaius(B): 58° 25′53.00″ N</p>
			<p>Idapikkus(L): 23° 40′56.00″ E</p>
		</>
	),
	'sadam.hinnakiri.lae': 'Lae hinnakiri alla',
	'sadam.hinnakiri.pealkiri': 'Varbla Puhkeküla sadamatasud 2020',
	'sadam.hinnakiri.tabelAlused': () => (
		<>
			<thead>
				<tr>
					<th colSpan='2'>Navigatsiooni hooaeg – 01.mai – 31.oktoober</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Alused, seisuajaga kuni 2 tundi</td>
					<td>tasuta</td>
				</tr>
				<tr>
					<td>Alused pikkusega kuni 8m</td>
					<td>15.-€ / 24h</td>
				</tr>
				<tr>
					<td>Alused pikkusega 8-10m</td>
					<td>20.-€ / 24h</td>
				</tr>
				<tr>
					<td>Alused pikkusega 10-13m</td>
					<td>25.-€ / 24h</td>
				</tr>
				<tr>
					<td>Alused pikkusega 13-20m</td>
					<td>30.-€ / 24h</td>
				</tr>
				<tr>
					<td>Alused pikkusega üle 20m</td>
					<td>3.50 jm / 24h</td>
				</tr>
				<tr>
					<td>Alused pikkusega kuni 20m seisuajaga 2- 8 tundi (ööbimiseta)</td>
					<td>10.-€</td>
				</tr>
				<tr>
					<td>Alused pikkusega üle 20m seisuajaga 2- 8 tundi (ööbimiseta)</td>
					<td>40.-€</td>
				</tr>
				<tr>
					<td>Ühekordne slipikasutus – (sisse-välja)</td>
					<td>8.-€</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<td colSpan='2'>
						<strong>Jahtide, kaatrite sadamatasu sisaldab: </strong>
						kaikoht, magevesi, elekter, WC kasutus, dussiruumi kasutus kuni
						4-le. Ujuvaluse eest makstav tasu ei sisalda sõiduki parkimist
						sadamaalal. Ujuvaluse turvalise kinnitamise eest vastatab aluse
						omanik või aluse kasutaja.
					</td>
				</tr>
			</tfoot>
		</>
	),
	'sadam.hinnakiri.tabelAlusedKodusadam': () => (
		<>
			<thead>
				<tr>
					<th colSpan='3'>
						Kaitasu alaliselt baseeruvatele jahtidele, kaatritele ja alustele
						(kodusadama alused)
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Alused, kuni 10 m</td>
					<td>100.-€ kuu (juuni-august)</td>
					<td>50.-€ kuu</td>
					<td>300.-€ hooaeg</td>
				</tr>
				<tr>
					<td>Alused, üle 10 – 13m</td>
					<td>150.-€ kuu (juuni-august)</td>
					<td>100.-€ kuu</td>
					<td>450.-€ hooaeg</td>
				</tr>
				<tr>
					<td>Alused, üle 13 – 20 m</td>
					<td>200.-€ kuu (juuni-august)</td>
					<td>150.-€ kuu</td>
					<td>550.-€ hooaeg</td>
				</tr>
				<tr>
					<td>Alused üle 20m ja enam</td>
					<td>300.-€ kuu (juuni-august)</td>
					<td>250.-€ kuu</td>
					<td>750.-€ hooaeg</td>
				</tr>
			</tbody>
		</>
	),
	'sadam.hinnakiri.tabelAlusedMitteKodusadam': () => (
		<>
			<thead>
				<tr>
					<th colSpan='3'>
						Kaitasu alaliselt baseeruvatele jahtidele, kaatritele ja alustele
						(mittekodusadama alused)
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Alused, kuni 10 m</td>
					<td>150.-€ kuu (juuni-august)</td>
					<td>80.-€ kuu</td>
					<td>400.-€ hooaeg</td>
				</tr>
				<tr>
					<td>Alused, üle 10 – 13m</td>
					<td>200.-€ kuu (juuni-august)</td>
					<td>130.-€ kuu</td>
					<td>550.-€ hooaeg</td>
				</tr>
				<tr>
					<td>Alused, üle 13 – 20 m</td>
					<td>250.-€ kuu (juuni-august)</td>
					<td>180.-€ kuu</td>
					<td>700.-€ hooaeg</td>
				</tr>
				<tr>
					<td>Alused üle 20m ja enam</td>
					<td>350.-€ kuu (juuni-august)</td>
					<td>280.-€ kuu</td>
					<td>1000.-€ hooaeg</td>
				</tr>
			</tbody>
		</>
	),
	'sadam.hinnakiri.tabelHeitmed': () => (
		<>
			<thead>
				<tr>
					<th colSpan='2'>Heitmete vastuvõtt</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Pilsivee vastuvõtt laevadelt</td>
					<td>70.-€ tonn</td>
				</tr>
				<tr>
					<td>Olmeprügi vastuvõtt laevadelt</td>
					<td>25.-€ m3</td>
				</tr>
				<tr>
					<td>Fekaali vastuvõtt laevadelt</td>
					<td>20.-€ tonn</td>
				</tr>
			</tbody>
		</>
	),
	'sadam.hinnakiri.tabelParkimine': () => (
		<>
			<thead>
				<tr>
					<th colSpan='3'>Tasuline parkimine sadamaparklas</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Sõiduauto</td>
					<td>2.-€ ööpäev</td>
					<td>20.-€ kuu</td>
				</tr>
				<tr>
					<td>Sõiduauto käru</td>
					<td>2.-€ ööpäev</td>
					<td>20.-€ kuu</td>
				</tr>
				<tr>
					<td>Buss/veoauto</td>
					<td>4.-€ ööpäev</td>
					<td>40.-€ kuu</td>
				</tr>
			</tbody>
		</>
	),
	'sadam.hinnakiri.tabelLisatasu': () => (
		<>
			<thead>
				<tr>
					<th colSpan='2'>Lisatasu eest</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Pesumasina kasutus</td>
					<td>4.-€ / masinatäis</td>
				</tr>
				<tr>
					<td>Dušši kasutamine</td>
					<td>3€ /inimene</td>
				</tr>
				<tr>
					<td>Saunakasutus</td>
					<td>30€ tund</td>
				</tr>
				<tr>
					<td>Käteräti laenutus</td>
					<td>2€ tk</td>
				</tr>
				<tr>
					<td>Telkimine</td>
					<td>3.-€ /inimene</td>
				</tr>
				<tr>
					<td>Jalgratta rent</td>
					<td>2.-€ /tund, 10.-€ /päev</td>
				</tr>
				<tr>
					<td>Aerupaadi rent</td>
					<td>7.-€ /tund, 30.-€ /päev</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<td colSpan='2'>Kõik hinnad sisaldavad 20% käibemaksu.</td>
				</tr>
			</tfoot>
		</>
	),
};

export default sadam;
